(function () {
  const toBoolean = (value) => value === true || value === "true";

  const getDesktopSlides = (productsToShow) => {
    return Math.max(1, Math.min(6, productsToShow));
  };

  const initPopularProductsSlider = (slider) => {
    if (!slider || slider.classList.contains("slider-started")) {
      return;
    }

    slider.classList.add("slider-started");

    const section = slider.closest(".popular-products");
    if (!section) {
      return;
    }

    const productsToShow = Number(slider.dataset.productsToShow) || 4;
    const columnsMobile = Number(slider.dataset.columnsMobile) || 1;
    const showNavigation = toBoolean(slider.dataset.navigation);
    const paginationEl = section.querySelector(".popular-products__pagination");

    let prevEl = null;
    let nextEl = null;

    if (showNavigation) {
      prevEl = section.querySelector(".popular-products__button--prev");
      nextEl = section.querySelector(".popular-products__button--next");

      if (document.documentElement.getAttribute("dir") === "rtl") {
        [prevEl, nextEl] = [nextEl, prevEl];
      }
    }

    const desktopSlides = getDesktopSlides(productsToShow);

    new Swiper(slider, {
      slidesPerView: columnsMobile,
      spaceBetween: 2,
      watchOverflow: true,
      breakpoints: {
        576: {
          slidesPerView: Math.max(2, Math.min(desktopSlides, 2)),
        },
        990: {
          slidesPerView: Math.min(desktopSlides, 3),
        },
        1100: {
          slidesPerView: Math.min(desktopSlides, 4),
        },
        1360: {
          slidesPerView: Math.min(desktopSlides, 5),
        },
        1600: {
          slidesPerView: desktopSlides,
        },
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: "progressbar",
          }
        : undefined,
      navigation:
        showNavigation && prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : undefined,
    });
  };

  const initPopularProductsSliders = (root = document) => {
    root
      .querySelectorAll(".js-popular-products-slider")
      .forEach((slider) => initPopularProductsSlider(slider));
  };

  document.addEventListener("DOMContentLoaded", function () {
    initPopularProductsSliders();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initPopularProductsSliders(event.target);
  });
})();
